var map = {
	"./custom-locales/de/common.json": 78032,
	"./custom-locales/de/common/base-layout.json": 28982,
	"./custom-locales/de/common/faq-meta.json": 93709,
	"./custom-locales/de/common/faq.json": 70920,
	"./custom-locales/de/data-protection.json": 15984,
	"./custom-locales/de/default.json": 93869,
	"./custom-locales/de/entityTypes/project.json": 54942,
	"./custom-locales/de/entityTypes/projectFollowership.json": 3461,
	"./custom-locales/de/entityTypes/sdg.json": 14474,
	"./custom-locales/de/entityTypes/supportRequest.json": 93497,
	"./custom-locales/de/entityTypes/user.json": 64661,
	"./custom-locales/de/error.json": 70345,
	"./custom-locales/de/management.json": 79457,
	"./custom-locales/de/pubtools.json": 59030,
	"./custom-locales/de/static/netiquette.json": 14952,
	"./custom-locales/de/terms-of-use.json": 13991,
	"./custom-locales/de/usecases/events.json": 57699,
	"./custom-locales/de/usecases/follow-project.json": 45092,
	"./custom-locales/de/usecases/my-projects.json": 474,
	"./custom-locales/de/usecases/network-project.json": 8010,
	"./custom-locales/de/usecases/onboarding.json": 91654,
	"./custom-locales/de/usecases/partner-market.json": 54309,
	"./custom-locales/en/common.json": 58645,
	"./custom-locales/en/common/base-layout.json": 39320,
	"./custom-locales/en/common/faq-meta.json": 26108,
	"./custom-locales/en/common/faq.json": 92506,
	"./custom-locales/en/data-protection.json": 54984,
	"./custom-locales/en/default.json": 64097,
	"./custom-locales/en/entityTypes/project.json": 6716,
	"./custom-locales/en/entityTypes/projectFollowership.json": 61270,
	"./custom-locales/en/entityTypes/sdg.json": 34609,
	"./custom-locales/en/entityTypes/supportRequest.json": 74221,
	"./custom-locales/en/entityTypes/user.json": 37780,
	"./custom-locales/en/error.json": 16274,
	"./custom-locales/en/management.json": 62186,
	"./custom-locales/en/pubtools.json": 4633,
	"./custom-locales/en/static/netiquette.json": 95371,
	"./custom-locales/en/terms-of-use.json": 60906,
	"./custom-locales/en/usecases/events.json": 83611,
	"./custom-locales/en/usecases/follow-project.json": 74409,
	"./custom-locales/en/usecases/my-projects.json": 79179,
	"./custom-locales/en/usecases/network-project.json": 19122,
	"./custom-locales/en/usecases/onboarding.json": 40273,
	"./custom-locales/en/usecases/partner-market.json": 86183,
	"./custom-locales/example.json": 5414,
	"./de/common.json": 21545,
	"./de/common/base-layout.json": 94482,
	"./de/common/faq-meta.json": 56345,
	"./de/common/faq.json": 69739,
	"./de/data-protection.json": 84522,
	"./de/default.json": 85216,
	"./de/entityTypes/project.json": 65695,
	"./de/entityTypes/projectFollowership.json": 81739,
	"./de/entityTypes/sdg.json": 68782,
	"./de/entityTypes/supportRequest.json": 90277,
	"./de/entityTypes/user.json": 13322,
	"./de/error.json": 44218,
	"./de/management.json": 14065,
	"./de/pubtools.json": 39876,
	"./de/static/netiquette.json": 40170,
	"./de/terms-of-use.json": 10786,
	"./de/usecases/events.json": 56135,
	"./de/usecases/follow-project.json": 58458,
	"./de/usecases/my-projects.json": 28766,
	"./de/usecases/network-project.json": 25508,
	"./de/usecases/onboarding.json": 34177,
	"./de/usecases/partner-market.json": 73895,
	"./en/common.json": 40464,
	"./en/common/base-layout.json": 49078,
	"./en/common/faq-meta.json": 27495,
	"./en/common/faq.json": 11604,
	"./en/data-protection.json": 75130,
	"./en/default.json": 88272,
	"./en/entityTypes/project.json": 59173,
	"./en/entityTypes/projectFollowership.json": 20718,
	"./en/entityTypes/sdg.json": 45218,
	"./en/entityTypes/supportRequest.json": 56131,
	"./en/entityTypes/user.json": 76874,
	"./en/error.json": 50394,
	"./en/management.json": 1766,
	"./en/pubtools.json": 57035,
	"./en/static/netiquette.json": 7961,
	"./en/terms-of-use.json": 31475,
	"./en/usecases/events.json": 35941,
	"./en/usecases/follow-project.json": 13638,
	"./en/usecases/my-projects.json": 67511,
	"./en/usecases/network-project.json": 64755,
	"./en/usecases/onboarding.json": 23500,
	"./en/usecases/partner-market.json": 82417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56848;